import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { from } from 'rxjs';
import { MatSliderModule } from '@angular/material/slider';
import { HttpClient, HttpHandler, HttpClientModule } from '@angular/common/http';
import { DataLogin } from './services/dataLogin.service';
import { LoginStep1Component } from './components/login-step1/login-step1.component';
import { LoginStep2Component } from './components/login-step2/login-step2.component';
import { BasicComponent } from './components/basic/basic.component';
import { CookieService } from 'ngx-cookie-service';
import { ContactsListComponent } from './components/contacts-list/contacts-list.component';
import { ComponentTitleComponent } from './components/component-title/component-title.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { PersonalAreaComponent } from './components/personal-area/personal-area.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { InquiriesComponent } from './components/inquiries/inquiries.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SearchContactPipe } from './_pipe/search-contact.pipe';
import { CreateContactDialogComponent } from './components/update-contact-dialog/create-contact-dialog.component';
import { DataService } from './services/data.service';
import { ScheduleDialogComponent } from './components/schedule-dialog/schedule-dialog.component';
import { ScheduleContactDialogComponent } from './components/schedule-contact-dialog/schedule-contact-dialog.component';
import { OnlyNumber } from './_directive/OnlyNumber';
import { CustomDateAdapter } from './models/custom.date.adapter';
import { NgxLoadersCssModule } from 'ngx-loaders-css';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PopoverModule } from "ngx-smart-popover";
import { DectivateStudentModalComponent } from './dectivate-student-modal/dectivate-student-modal.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { VacationDialogComponent } from './components/vacation-dialog/vacation-dialog.component';
import { VacationCalendarComponent } from './components/vacation-calendar/vacation-calendar.component'; // import bn-ng-idle service
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { JwPaginationComponent, JwPaginationModule } from 'jw-angular-pagination';
import { SugHasaaPipe } from './_pipe/sug-hasaa.pipe';
import { InstitutionDetailsComponent } from './components/institution-details/institution-details.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RoutesListComponent } from './components/routes-list/routes-list.component';
import { InstitutionCalendarMainComponent } from './components/institution-calendar/institution-calendar-main/institution-calendar-main.component';
import { InstitutionScheduleComponent } from './components/institution-calendar/institution-schedule/institution-schedule.component';
import { CalendarComponent } from './components/institution-calendar/calendar/calendar.component';
import { CreateInquiryDialogComponent } from './components/create-inquiry-dialog/create-inquiry-dialog.component';
import { MessageDisplayDialogComponent } from './components/message-display-dialog/message-display-dialog.component';
import { ScheduleGridComponent } from './components/institution-calendar/schedule-grid/schedule-grid.component';
import { StudentsSearchComponent } from './components/institution-calendar/students-search/students-search.component';
import { ClassScheduleListComponent } from './components/institution-calendar/class-schedule-list/class-schedule-list.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { VacationListComponent } from './components/institution-calendar/vacation-list/vacation-list.component';
import { StudentListComponent } from './components/institution-calendar/student-list/student-list.component';
import { StudentScheduleComponent } from './components/institution-calendar/student-schedule/student-schedule.component';
import { SpecialVacationComponent } from './components/institution-calendar/special-vacation/special-vacation.component';
import { AccountVacationDialogComponent } from './components/institution-calendar/account-vacation-dialog/account-vacation-dialog.component';
import { ComponentSwitcherComponent } from './components/institution-calendar/component-switcher/component-switcher.component';
import { MultiSelectSearchComponent } from './components/institution-calendar/multi-select-search/multi-select-search.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { SaveStudentsDialogComponent } from './components/institution-calendar/save-students-dialog/save-students-dialog.component';
import { DateFormatPipe } from './_pipe/date-format.pipe';
import { AuthoritiesStatusDialogComponent } from './components/institution-calendar/authorities-status-dialog/authorities-status-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddClassScheduleDialogComponent } from './components/institution-calendar/add-class-schedule-dialog/add-class-schedule-dialog.component';

interface NgxSpinnerConfig {
  type?: string;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginStep1Component,
    LoginStep2Component,
    BasicComponent,
    ContactsListComponent,
    ComponentTitleComponent,
    ScheduleListComponent,
    HomePageComponent,
    PersonalAreaComponent,
    NotificationsComponent,
    InquiriesComponent,
    SearchContactPipe,
    CreateContactDialogComponent,
    ScheduleDialogComponent,
    ScheduleContactDialogComponent,
    OnlyNumber,
    DectivateStudentModalComponent,
    VacationDialogComponent,
    VacationCalendarComponent,
    SugHasaaPipe,
    InstitutionDetailsComponent,
    RoutesListComponent,
    InstitutionCalendarMainComponent,
    InstitutionScheduleComponent,
    CalendarComponent,
    CreateInquiryDialogComponent,
    MessageDisplayDialogComponent,
    ScheduleGridComponent,
    StudentsSearchComponent,
    ClassScheduleListComponent,
    VacationListComponent,
    StudentListComponent,
    StudentScheduleComponent,
    SpecialVacationComponent,
    AccountVacationDialogComponent,
    ComponentSwitcherComponent,
    MultiSelectSearchComponent,
    SaveStudentsDialogComponent,
    DateFormatPipe,
    AuthoritiesStatusDialogComponent,
    AddClassScheduleDialogComponent,
  ],

  imports: [
    JwPaginationModule,
    NgSelectModule,
    BrowserModule,
    PopoverModule,
    MatTooltipModule,
    NgxLoadersCssModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatSelectModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatSidenavModule,
    MatIconModule,
    MatTabsModule,
    MatCardModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    NgMultiSelectDropDownModule.forRoot(),
    FullCalendarModule // register FullCalendar with your app
  ],
  providers: [
    DatePipe,
    BnNgIdleService,
    DataService,
    DataLogin,
    CookieService,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
  entryComponents:
    [CreateContactDialogComponent,
      ScheduleDialogComponent,
      ScheduleContactDialogComponent,
      DectivateStudentModalComponent,
      VacationDialogComponent,
      CreateInquiryDialogComponent,
      MessageDisplayDialogComponent,
      AccountVacationDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule {


}
